import { useTranslation } from "react-i18next";
import { StandardTextFieldProps, TextField } from "@mui/material";
import { useField } from "formik";
import { useCallback, useEffect, useState } from "react";
import { debounced } from "./utils";

interface FormTextFieldProps extends StandardTextFieldProps {
    name: string,
    readOnly?: boolean,
    maxLength?: number
}

const FormTextField = ({
    name,
    readOnly,
    maxLength,
    ...textFieldProps
}: FormTextFieldProps) => {
    const {t} = useTranslation(['network', 'translation']);

    // Use Field
    const [field, meta, helper] = useField(name);

    const [innerValue, setState] = useState<String>(field.value || '');
    const changeCB = useCallback(debounced(field.onChange), []);

    useEffect(() => {
        if (field.value !== undefined)
            setState(field.value);
    }, [field.value])

    return (
        <TextField
            {...textFieldProps}
            name={name}
            fullWidth
            value={innerValue}
            onBlur={field.onBlur}
            error={!!meta.error}
            onChange={(e) => {
                setState(e.target.value);
                changeCB(e)
            }}
            helperText={t((meta.error || textFieldProps.helperText) as string)}
            InputProps={{
                readOnly
            }}
        />
    );
};

export default FormTextField;
